'use client'

import { useEffect, useState } from 'react'
import { IconArrowsSort } from '@tabler/icons-react'
import clsx from 'clsx'
import { usePathname, useRouter, useSearchParams } from 'next/navigation'
import qs from 'qs'
import { dissoc } from 'ramda'

import {
  getSelectValueBySortingOptions,
  getSortingOptionsBySelectValue,
  SORTING_OPTIONS,
  SortingOptionsTypes,
  useFilterChange
} from 'modules/products'
import Button from 'shared/ui/Button'
import { Drawer, DrawerTitle } from 'shared/ui/Drawer'
import { searchParamsToParsedUrlQuery } from 'shared/utils/common'
import { addTestId } from 'shared/utils/tests'

import styles from './MobileSortingModal.module.scss'

const MobileSortingModal = () => {
  const [open, setOpen] = useState(false)
  const [sorting, setSorting] = useState<string | string[]>('name-asc')
  const router = useRouter()
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const { setLastFilterChange } = useFilterChange()

  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  const handleSortingChange =
    (value: string | string[]) => async (): Promise<void> => {
      setLastFilterChange(new Date())
      setSorting(value)

      const sortingOptions = getSortingOptionsBySelectValue(value)

      const parsedQuery = searchParamsToParsedUrlQuery(searchParams)

      if (value === 'recommended') {
        delete parsedQuery?.order
        delete parsedQuery?.sort_by
      }

      const params = qs.stringify(
        { ...dissoc('entity', parsedQuery), ...sortingOptions },
        { addQueryPrefix: true }
      )

      handleClose()
      router.replace(`${pathname || ''}${decodeURIComponent(params)}`)
    }

  // check sorting option in url
  useEffect(() => {
    const parsedQuery = searchParamsToParsedUrlQuery(searchParams)
    const sortingToCheck = {
      sort_by: parsedQuery.sort_by,
      order: parsedQuery.order
    } as SortingOptionsTypes

    const sortingName = getSelectValueBySortingOptions(sortingToCheck)

    if (sortingName !== sorting) {
      setSorting(sortingName)
    }
  }, [searchParams, sorting])

  return (
    <>
      <Button
        variant='neutralOutline'
        startIcon={<IconArrowsSort />}
        onClick={handleOpen}
        size='small'
        fullWidth
        {...addTestId('sorting-input')}
      >
        Sortuj
      </Button>
      <Drawer
        placement='left'
        open={open}
        onClose={handleClose}
        id='mobile-sorting-modal'
      >
        <DrawerTitle>Wybierz sortowanie</DrawerTitle>
        {SORTING_OPTIONS.map(option => (
          <div
            key={option.value}
            className={clsx(styles.sortingOption, {
              [styles.active]: sorting === option.value
            })}
            onClick={handleSortingChange(option.value)}
          >
            {option.label}
          </div>
        ))}
      </Drawer>
    </>
  )
}

export default MobileSortingModal
